export const UPC_SCAN_SAVE_REQUEST = "UPC_SCAN_SAVE_REQUEST";
export const UPC_SCAN_SAVE_SUCCESS = "UPC_SCAN_SAVE_SUCCESS";
export const UPC_SCAN_SAVE_FAIL = "UPC_SCAN_SAVE_FAIL";
export const UPC_SCAN_SAVE_RESET = "UPC_SCAN_SAVE_RESET";

export const UPC_SCAN_EXPORT_REQUEST = "UPC_SCAN_EXPORT_REQUEST";
export const UPC_SCAN_EXPORT_SUCCESS = "UPC_SCAN_EXPORT_SUCCESS";
export const UPC_SCAN_EXPORT_FAIL = "UPC_SCAN_EXPORT_FAIL";


export const MY_UPC_SLIPS_REQUEST = "MY_UPC_SLIPS_REQUEST";
export const MY_UPC_SLIPS_SUCCESS = "MY_UPC_SLIPS_SUCCESS";
export const MY_UPC_SLIPS_FAIL = "MY_UPC_SLIPS_FAIL";

export const EXPORT_UPC_EXCEL_REQUEST = "EXPORT_UPC_EXCEL_REQUEST";
export const EXPORT_UPC_EXCEL_SUCCESS = "EXPORT_UPC_EXCEL_SUCCESS";
export const EXPORT_UPC_EXCEL_FAIL = "EXPORT_UPC_EXCEL_FAIL";




export const CREATE_MAPPING_REQUEST = "CREATE_MAPPING_REQUEST";
export const CREATE_MAPPING_SUCCESS = "CREATE_MAPPING_SUCCESS";
export const CREATE_MAPPING_FAIL = "CREATE_MAPPING_FAIL";
export const CREATE_MAPPING_RESET = "CREATE_MAPPING_RESET";


export const ALL_MAPPINGS_REQUEST = "ALL_MAPPINGS_REQUEST";
export const ALL_MAPPINGS_SUCCESS = "ALL_MAPPINGS_SUCCESS";
export const ALL_MAPPINGS_FAIL = "ALL_MAPPINGS_RESET";


export const UPDATE_MAPPING_REQUEST = "UPDATE_MAPPING_REQUEST";
export const UPDATE_MAPPING_SUCCESS = "UPDATE_MAPPING_SUCCESS";
export const UPDATE_MAPPING_FAIL = "UPDATE_MAPPING_FAIL";
export const UPDATE_MAPPING_RESET = "UPDATE_MAPPING_RESET";


export const DELETE_MAPPING_REQUEST = "DELETE_MAPPING_REQUEST";
export const DELETE_MAPPING_SUCCESS = "DELETE_MAPPING_UCCESS";
export const DELETE_MAPPING_FAIL = "DELETE_MAPPING_FAIL";
export const DELETE_MAPPING_RESET = "DELETE_MAPPING_RESET";



export const CLEAR_ERRORS = "CLEAR_ERRORS";
